import AllCoupons from "../../../components/Coupons/AllCoupons";

function Coupons() {
    return ( 
        <div>
            <AllCoupons />
        </div>
     );
}

export default Coupons;